import soul from '@/soul'
import { useRootStore } from '@/stores/root'
import { useVisitorStore } from '@/stores/visitor'
import HttpClient from '@utils/httpclient'

const http = HttpClient.getInstance(
	{
		baseURL: soul.backEndHost,
		timeout: 5000
	},
	{
		'X-Requested-With': 'API/adminxx'
	},
	{
		401: () => {
			const visitorStore = useVisitorStore()
			visitorStore.clearLogin()
			useRootStore().setShowLogin(true)
		}
	}
)

export default http
